import React, { useEffect } from "react";
import {
  Navigate,
  useLocation,
  useNavigationType,
  useRoutes,
  useSearchParams,
} from "react-router-dom";
import AddVehicule from "../Components/vehicule/AddVehicule";
import AboutUs from "../domains/pages/AboutUs";
import { rememberLastPage } from "../utils/lastPage";
import FAQ from "../domains/pages/FAQ";
import Home from "../domains/pages/Home";
import Login from "../domains/pages/Login";
import Offres from "../domains/pages/Offres";
import Order from "../domains/pages/order/Order";
import OurBranches from "../domains/pages/OurBranches";
import OurPartners from "../domains/pages/OurPartners";
import Profil from "../domains/pages/Profil/Profil";
import Detail from "../domains/pages/Shop/Detail";
import ServicesList from "../domains/pages/Shop/ServicesList";
import ShopList from "../domains/pages/Shop/ShopList";
import Warranty from "../domains/pages/Warranty";
import ProtectedRoute from "./ProtectedRoute";
import NewsList from "../domains/pages/news/NewsList";
import NewsDetail from "../domains/pages/news/NewsDetail";
import LoyaltyProgramInternal from "../domains/pages/LoyaltyProgram";
import Jobs from "../domains/pages/jobs/Jobs";
import ResultPaymentPage from "../domains/pages/ResultPaymentPage";
import OffersDetails from "../domains/pages/OffersDetails";
import Privacy from "../domains/pages/Sections/Privacy";
import Terms from "../domains/pages/Sections/TermsConditions";
import SearchPage from "../domains/Menu/SearchPage";
import ContactUs from "../domains/pages/ContactUs";
import ResetPassword from "../domains/pages/ResetPassword";
import ReturnChange from "../domains/pages/Sections/ReturnChange";
import ResultMadaPage from "../domains/pages/ResultMadaPage";
const ResetPasswordGuard = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("id");

  return token ? <ResetPassword /> : <Navigate to="/" replace />;
};
const AppRoutes: React.FC = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (!location.pathname.startsWith("/result")) {
      rememberLastPage(location.pathname + location.search);
    }
  }, [location.pathname, location.search]);
  useEffect(() => {
    if (navigationType === "POP") {
      return;
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location, navigationType]);

  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/warranty", element: <Warranty /> },
    { path: "/about", element: <AboutUs /> },
    { path: "/our-branches", element: <OurBranches /> },
    { path: "/our-partners", element: <OurPartners /> },
    { path: "/offers", element: <Offres /> },
    { path: "/offer-detail", element: <OffersDetails /> },
    { path: "/faq", element: <FAQ /> },
    { path: "/loyalty-program", element: <LoyaltyProgramInternal /> },
    { path: "/Jobs", element: <Jobs /> },
    { path: "/login", element: <Login /> },
    { path: "/result", element: <ResultPaymentPage /> },
    { path: "/result-mada", element: <ResultMadaPage /> },

    {
      path: "/services",
      element: <ServicesList />,
    },
    { path: "/products", element: <ShopList /> },
    { path: "/detail", element: <Detail /> },
    { path: "/news", element: <NewsList /> },
    { path: "/news-detail", element: <NewsDetail /> },
    { path: "/add-car", element: <AddVehicule /> },
    { path: "/order", element: <Order /> },
    { path: "/privacy-policy", element: <Privacy /> },
    { path: "/terms-conditions", element: <Terms /> },
    { path: "/return-policy", element: <ReturnChange /> },

    { path: "/search", element: <SearchPage /> },
    { path: "/contact-us", element: <ContactUs /> },
    { path: "/reset_password", element: <ResetPasswordGuard /> },
    { path: "/profile", element: <ProtectedRoute children={<Profil />} /> },
    { path: "*", element: <Navigate to="/" replace /> },
  ]);

  return routes;
};

export default AppRoutes;
